import React, { Component } from 'react'
import Mark from './Mark'

export default class Footer extends Component {
  render() {
    return (
      <div className='footer'>
        <span>Copyright ©2023 All rights reserved | This page is made with <img src='https://cdn-icons-png.flaticon.com/512/2589/2589175.png' alt='love' width='15px' height='15px'></img> for Group 19</span>
        <Mark/>
      </div>
      
    )
  }
}
